import { CustomSelectType } from "./CustomSelectType";

export interface EmploymentType {
  value: string | undefined;
  label: string;
}

export const EmploymentType: Array<CustomSelectType> = [
  {
    value: undefined,
    label: "Select employment type",
  },
  {
    value: "full-time",
    label: "Full time",
  },
  {
    value: "part-time",
    label: "Part time",
  },
  {
    value: "casual",
    label: "Casual",
  },
];
